import { render, staticRenderFns } from "./DebugPermissions.vue?vue&type=template&id=626f3350&scoped=true"
import script from "./DebugPermissions.vue?vue&type=script&lang=js"
export * from "./DebugPermissions.vue?vue&type=script&lang=js"
import style0 from "./DebugPermissions.vue?vue&type=style&index=0&id=626f3350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f3350",
  null
  
)

export default component.exports